import React from "react";
import PropTypes from "prop-types";

import "./story-subheadline.module.css";

export const StorySubheadline = ({ subheadline, subheadlineWhite }) => {
  const color = subheadlineWhite ? "summary subheadline-color" : "summary";
  return (
    <p data-testid="subheadline" styleName={`${color}`}>
      <bdi dangerouslySetInnerHTML={{ __html: subheadline }} />
    </p>
  );
};

StorySubheadline.propTypes = {
  subheadline: PropTypes.string.isRequired,
  subheadlineWhite: PropTypes.string
};
